import React, { useEffect, useState } from "react";
import Main from "../Main";
import { Box, Button, TablePagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSellerOrders } from "../../../Redux/OrderRedux";
import OrderTable from "./OrderTable";

function MyOrders() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Processing");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [inProgress, setInProgress] = useState("");
  const [delivered, setDelivered] = useState("");
  const [cancelled, setCancelled] = useState("");
  const dispatch = useDispatch();
  const { sellerOrders } = useSelector((state) => state.orderRedux);

  const paginatedInProgress = inProgress.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const paginatedDelivered = delivered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const paginatedCancelled = cancelled.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    if (sellerOrders) {
      setInProgress(
        sellerOrders.filter((order) =>
          order.products?.some((p) =>
            ["NewOrder", "Packed", "Shipped"].includes(p.status)
          )
        )
      );
      setDelivered(
        sellerOrders.filter((order) =>
          order.products?.some((p) => p.status === "Delivered")
        )
      );
      setCancelled(
        sellerOrders.filter((order) =>
          order.products?.some((p) =>
            ["Cancelled", "PaymentPending", "PaymentFailed"].includes(p.status)
          )
        )
      );
    } else {
      setInProgress([]);
      setDelivered([]);
      setCancelled([]);
    }
  }, [sellerOrders]);

  const userId =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).userId;

  useEffect(() => {
    dispatch(getSellerOrders(userId));
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOrders = (orders) => {
    navigate(`/myAccount/orders/orderDetails/${orders.orderId}/${userId}`);
  };

  return (
    <Main>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>My Orders</h4>
            </div>
          </div>
          <div className="row mt-2">
            <ul className="nav nav-pills d-flex justify-content-evenly w-100">
              <li
                className="nav-item col-12 col-md-4 text-center border rounded-5 p-1"
                style={{
                  backgroundColor:
                    activeTab === "Processing" ? "#FFC72C" : "transparent",
                  color: activeTab === "Processing" ? "#fff" : "#FFC72C",
                  cursor: "pointer",
                }}
                onClick={() => handleTabClick("Processing")}
              >
                Processing
              </li>

              <li
                className="nav-item col-12 col-md-4 text-center border rounded-5 p-1"
                style={{
                  backgroundColor:
                    activeTab === "Delivered" ? "#198754" : "transparent",
                  color: activeTab === "Delivered" ? "#fff" : "#136c19",
                  cursor: "pointer",
                }}
                onClick={() => handleTabClick("Delivered")}
              >
                Delivered
              </li>

              <li
                className="nav-item col-12 col-md-4 text-center border rounded-5 p-1"
                style={{
                  backgroundColor:
                    activeTab === "Cancelled" ? "#ED2939" : "transparent",
                  color: activeTab === "Cancelled" ? "#fff" : "#ED2939",
                  cursor: "pointer",
                }}
                onClick={() => handleTabClick("Cancelled")}
              >
                Cancelled / Returned
              </li>
            </ul>
          </div>
          <div className="row mt-5">
            <div className="col-12">
              <OrderTable
                sellerOrders={
                  activeTab === "Processing"
                    ? paginatedInProgress
                    : activeTab === "Delivered"
                    ? paginatedDelivered
                    : activeTab === "Cancelled"
                    ? paginatedCancelled
                    : []
                }
                orderData={handleOrders}
              />
            </div>
          </div>
        </div>
      </Box>
      <div className="my-3 d-flex justify-content-end me-5">
        <TablePagination
          component="div"
          count={
            activeTab == "Delivered"
              ? delivered.length
              : activeTab == "Processing"
              ? inProgress.length
              : cancelled.length
          }
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </Main>
  );
}

export default MyOrders;
